import {RouteProps} from 'config/navigation';
import {FaList} from 'react-icons/fa';

import Categories from './categories';
import CreateCategory from './create-category';
import EditCategory from './edit-category';
import ReorderCategory from './reorder-category';

const categoriesPages: RouteProps = {
  name: 'Categorias',
  path: 'categories',
  permission: 'categories.findAll',
  icon: <FaList />,
  subRoutes: [
    {
      path: '',
      element: <Categories />,
      permissions: ['categories.findAll'],
      modals: [{path: 'reorder', element: <ReorderCategory />}],
    },
    {
      path: 'create',
      element: <CreateCategory />,
      permissions: ['categories.findOne'],
    },
    {
      path: ':id',
      element: <EditCategory />,
      permissions: ['categories.findOne'],
    },
  ],
};

export default categoriesPages;
